import React from "react";

export const Services = () => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            Nice Touch is the premier Home Support Services Company in
            Kenya. We provide quality assured Home Cleaning & Support Services.
            The company is located in Nairobi, Kenya. At Nice Touch, our passion is
            to enable you enjoy life, to achieve your dream of a life free of
            needless hassles …. so that you can have time for what really
            matters to you. 
          </p>
        </div>
        <a href="/services" className="btn btn-custom btn-lg">
          Get Started
        </a>{" "}
      </div>
    </div>
  );
};
